import { navigate } from 'gatsby';
import ApiBuilder from'../helpers/ApiBuilder'
const { DEV_PORTAL_API } = ApiBuilder

const getUserNotification = (page = 1, pageSize = 50) => {
    return DEV_PORTAL_API.get('api/notification', {
        params: {
            page,
            pageSize
        }
    });
}
const markAsRead = (noificationIds) => {
    return DEV_PORTAL_API.put('api/notification/read', noificationIds)
}

const handleNotification = (notification) => {
    switch (notification.entityType) {
        case 'Application':
            navigate(`/manage-apps/apps/${notification.entityId}`)
            break;
        case 'Release':
            navigate(`/manage-apps/releases/${notification.entityId}`)
            break;
        default:
            break;
    }
}



export default {
    getUserNotification,
    markAsRead,
    handleNotification
}